module.exports = __webpack_public_path__ + "/fonts/opensansbold.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/opensans-npm-webfont/fonts/opensansbold.woff
// module id = 209
// module chunks = 0